<template>
  <div>
    <select-base
      v-model="value"
      :disabled="disabled"
      :require="require_"
      :multiple="multiple"
      :label="label"
      :label-select="'nome'"
      :carregar="carregarEnquadramentos"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
import api from './api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'EnquadramentoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
    label: {
      type: String,
      default: 'Enquadramento',
    },
  },
  data() {
    return {
      filtros: [
        {
          coluna: 'Nome',
          valor: '',
        },
      ],
    }
  },
  computed: {

    require_: {
      get() {
        return this.require
      },
    },
  },
  methods: {
    carregarEnquadramentos(filtros) {
      return api.getEnquadramentosResumidos(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.value)
    },
  },
}
</script>
